import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";

const categoryImages = [
  "https://readdy.ai/api/search-image?query=Premium%20athletic%20sneakers%20displayed%20on%20polished%20marble%20surface%2C%20soft%20studio%20light%20from%20above%2C%20warm%20ivory%20background%2C%20editorial%20fashion%20photography%2C%20sharp%20detail%2C%20clean%20composition&width=600&height=450&seq=cat-card-sneakers-uniq&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Oversized%20premium%20hoodie%20draped%20on%20minimal%20wooden%20hanger%2C%20soft%20studio%20lighting%2C%20warm%20cream%20background%2C%20editorial%20streetwear%20photography%2C%20textured%20fabric%20detail&width=600&height=450&seq=cat-card-hoodie-uniq&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Three%20folded%20organic%20cotton%20t-shirts%20in%20neutral%20tones%2C%20minimalist%20display%20on%20light%20wood%2C%20soft%20natural%20studio%20light%2C%20warm%20background%2C%20clean%20modern%20fashion%20aesthetic&width=600&height=450&seq=cat-card-tshirts-uniq&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Stylish%20bomber%20jacket%20on%20minimalist%20display%2C%20soft%20studio%20lighting%2C%20warm%20beige%20background%2C%20editorial%20fashion%20photography%2C%20clean%20composition%2C%20modern%20outerwear%20style&width=600&height=450&seq=cat-card-jacket-uniq&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Well-tailored%20casual%20trousers%20folded%20on%20clean%20surface%2C%20soft%20studio%20lighting%2C%20warm%20cream%20background%2C%20minimalist%20fashion%20photography%2C%20modern%20style&width=600&height=450&seq=cat-card-pants-uniq&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Premium%20baseball%20cap%20displayed%20on%20minimal%20pedestal%2C%20soft%20studio%20lighting%2C%20warm%20neutral%20background%2C%20clean%20product%20photography%2C%20contemporary%20headwear%20style&width=600&height=450&seq=cat-card-hat-uniq&orientation=landscape",
];

export default function ProductCategories() {
  const { t } = useTranslation();

  const displayCategories = categories.slice(0, 6);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end gap-4 mb-10 md:mb-14">
          <div className="flex-1">
            <span className="font-heading text-3xl md:text-5xl font-light text-foreground-400 block leading-tight">
              {t("products.title1")}
            </span>
            <span className="font-heading text-3xl md:text-5xl font-bold italic text-foreground-950 block leading-tight">
              {t("products.title2")}
            </span>
          </div>
          <p className="text-sm text-foreground-600 max-w-md">
            {t("products.description")}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-10">
          {displayCategories.map((cat, idx) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group rounded-xl overflow-hidden border border-background-200/70 bg-background-50 hover:shadow-md transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={categoryImages[idx]}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-xs font-medium text-accent-700 mb-2">
                  Kategoria
                </span>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950">
                  {cat.name}
                </h3>
              </div>
            </a>
          ))}
        </div>

        <div className="flex flex-wrap gap-2 justify-center" data-product-shop>
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-primary-300 text-xs font-medium text-primary-600 hover:bg-primary-50 hover:border-primary-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className={`${cat.icon} text-xs`}></i>
              </div>
              {cat.name}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}